export default __webpack_public_path__ + "static/media/coinIcon.662b45a6.svg";